// 数组转树结构
function sortArr(a, b) {
  return a.orderNum - b.orderNum;
}

export function arrayToTree(
  list,
  callback = () => {},
  props = { id: "id", pid: "pid", children: "children" }
) {
  list.sort(sortArr);
  const tree = [];
  const map = {};

  // list = cloneObj(list);

  const listLength = list.length;
  for (let i = 0; i < listLength; i++) {
    const node = list[i];
    const nodeId = node[props.id];
    map[nodeId] = node;
    callback(node);
  }

  for (let i = 0; i < listLength; i++) {
    const node = list[i];
    const nodePid = node[props.pid];
    const parentNode = map[nodePid];
    if (parentNode) {
      parentNode[props.children] = parentNode[props.children] || [];
      parentNode[props.children].push(node);
    } else {
      tree.push(node);
    }
  }

  return tree;
}
